import Vue from "vue";
import Vuex from "vuex";
import clubs from "./modules/clubs";
import user from "./modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    clubs,
    user
  }
});
